<template>
<div>
<div class="pop_title">유관 사업</div>
<div class="pop_table04 scroll">
    <table class="tb-list01" summary="유관 사업">
        <caption>유관 사업목록</caption>
        <colgroup>
            <col style="width:18%">
            <col style="width:50%">
            <col style="width:32%">
        </colgroup>
        <thead>
        <tr>
            <th>구분</th>
            <th>사업명</th>
            <th>총괄부서</th>
        </tr>
        </thead>
        <tbody>
         <tr v-for="promise in relevantBizList" :key="promise.amnDataSqno">
            <td>{{diagName}}</td>
            <td class="alignL"><div class="text-ellipsis">{{ promise.val2 }}</div></td>
            <td>{{ promise.val3 }}</td>
        </tr>
        </tbody>
    </table>
</div>
</div>
</template>

<script>
export default {
    name: 'RelevantBizList',
    props: {
        promiseInfo: {
            type: Object,
            required: true
        },
        diagName: ''
    },
    computed: {
        relevantBizList() {
            return this.$store.getters.getRelevantBizList;
        }
    },
    watch: {
        promiseInfo: {
            immediate: true,
            handler(newVal, oldVal) {
                var q = "";
                if(typeof this.promiseInfo.amnDataSqno !== 'undefined') {
                     if(this.promiseInfo.val9) {
                         this.$store.dispatch('FETCH_RELEVANT_BIZ_LIST', this.promiseInfo);
                     }
                }
            }
        }
    },
    methods: {
        mvBizDetail(bizInfo) {
            location.href = _WC.cp + "/ep/biz/promise/" + bizInfo.dataKdSqno + "/" + bizInfo.amnDataSqno; 
        }
    }
}
</script>

<style scoped>

</style>